module.exports = __webpack_public_path__ + "img/mini_program.1acd2d84.jpg";